import React from 'react';

const AboutSection = () => {
  const tags = [
    "Product Engineering",
    "Full Stack Systems",
    "Scalable Architecture",
    "Cloud & DevOps",
    "High Performance Apps",
    "API & Integrations",
    "Microservices Design",
    "Database Engineering",
    "Security First",
    "Clean & Maintainable Code"
  ];

  return (
    <section className="bg-black text-white py-24 px-6 font-sans">
      <div className="max-w-6xl mx-auto">

        {/* Top Heading Section */}
        <div className="text-center mb-16">
          <p className="text-[#0ed6b7] text-[10px] font-bold tracking-[3px] uppercase mb-4">
            YOUR PROSPECTING PARTNER
          </p>
          <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight">
            Meet <span className="text-[#0ed6b7]">Studio Pulse</span>
          </h2>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">

          {/* Left Side: Image Container */}
          <div className="lg:col-span-5 flex justify-center lg:justify-end">
            <div className="relative group max-w-sm w-full">

              <img
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=1000&auto=format&fit=crop"
                alt="Founder"
                className="rounded-2xl w-full h-[450px] object-cover grayscale brightness-90 border border-slate-800 transition-all duration-500 group-hover:grayscale-0"
              />

              <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>
          </div>

          {/* Right Side: Text Content */}
          <div className="lg:col-span-7 space-y-6">

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">

              {/* Left Side: Image Container */}
              

              {/* Right Side: Text Content */}
              <div className="lg:col-span-12 space-y-6">

                <p className="text-slate-200 text-lg font-medium leading-relaxed">
                  Most development agencies focus on delivering code. We focus on building products that actually scale and solve real business problems.
                </p>

                <p className="text-slate-400 text-base leading-relaxed">
                  With years of hands-on experience in software development, system architecture, and real-world product building, we've worked on applications that handle real users, real data, and real growth challenges. From startups to growing businesses, we've helped turn ideas into reliable, production-ready systems.
                </p>

                <p className="text-slate-400 text-base leading-relaxed">
                  Every project we take on is built with a clear focus on performance, scalability, and long-term maintainability. No shortcuts, no unnecessary complexity — just clean architecture and efficient execution designed for real-world success.
                </p>

                <p className="text-sm text-slate-500 pt-4">
                  — Building software that actually works in the real world
                </p>
                {/* Tag Cloud */}
                <div className="pt-6 flex flex-wrap gap-3">
                  {tags.map((tag, index) => (
                    <span
                      key={index}
                      className="px-4 py-2 rounded-full border border-slate-800 bg-[#0f1115] text-[12px] font-medium text-[#0ed6b7]/90 hover:border-[#0ed6b7]/40 transition-colors cursor-default"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

              </div>

            </div>

           

          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutSection;